module.exports = __webpack_public_path__ + "img/icon_loan_waiting_review.bc59a974.png";